import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function utilRoutes($stateProvider: StateProvider) {
    let utilModule: { default: any; };
    let activeSessionsModule: { default: any; };

    $stateProvider
        .state({
            name: 'util',
            url: '/util',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => utilModule.default,
            },
            lazyLoad: async () => {
                utilModule = await import(/* webpackChunkName: "utilPage" */ './KpUtilPage.svelte');
                return null;
            }
        })
        .state({
            name: 'active-sessions',
            url: '/active-sessions',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => activeSessionsModule.default,
            },
            lazyLoad: async () => {
                activeSessionsModule = await import(/* webpackChunkName: "activeSessionsPage" */ './KpActiveSessionsPage.svelte');
                return null;
            }
        });
}